const NotFound = () => (
  <div className='container center'>
    404 Not Found
  </div>
)

export default NotFound
